import React from "react";
import "../Styles/about1.css";
import Picture from '../Picture.jpeg';
import { Button } from "@nextui-org/react";
import { IoIosContacts } from "react-icons/io";
import { MdSubscriptions } from "react-icons/md";
import { FaCircleCheck } from "react-icons/fa6";
import photo from '../photo.jpeg'
import { Card, CardBody } from "@nextui-org/react";
import { CiTwitter } from "react-icons/ci";
import { Link } from "@nextui-org/react";


function Aggreator() {
    return (

        <div id="aggregator" style={{ background: " linear-gradient(147.35deg, rgb(35, 35, 36) -0.9%, rgb(21, 21, 22) 116.23%)" }}>
            <div className="Aggreator-1">
                <div class="aggre-1">
                    <div class="agg1 sm:hidden lg:block">
                        <img className="picture" src={Picture} alt="Picture of the" />
                    </div>
                    <div class="agg2">
                        <div class="agg2-1">
                            <Button radius="full" className="font-gothica1 font-[600] text-[14px]" style={{ color: 'white', background: "linear-gradient(90deg, rgb(209, 160, 255) 0%, rgb(218, 191, 255) 100%)" }}>
                                FIRST WEB3 CRYPTO
                            </Button>
                        </div>
                        <div class="agg2-2" className="font-syne font-[700]">
                            <h2 style={{ fontSize: '46px', paddingLeft: '30px', paddingRight: '40px', color: 'white', lineHeight: '54px' }}>Keeping track of projects in</h2>
                            <h2 style={{ fontSize: '46px', paddingLeft: '30px', paddingRight: '80px', color: '#ffb3ff', lineHeight: '54px' }}>one place</h2>
                        </div>
                        <div class="agg2-3">
                            <p className="font-gothica1 font-[400] text-[15px]" style={{ lineHeight: '25px', color: 'rgb(131, 131, 131)', paddingLeft: '30px', marginTop: "45px" }}>The NFD.gg aggregator allows you to create a specific card of any project and parse any type of information from Discord, Twitter, Dune Analytics, TradingView, Github etc. into your own dashboard.</p>
                        </div>
                        <div class="agg2-4 mt-6">
                            <div class="flex justify-center items-center flex-col lg:flex-row">
                                <div style={{ color: 'white', padding: '20px' }} >
                                    <Button color="secondary" style={{ paddingLeft: '40px', paddingRight: '40px', fontWeight: 800, fontSize: '20px' }} >
                                        Secondary
                                    </Button>
                                </div>
                                <div style={{ color: 'white', padding: '20px' }}>
                                    <Link href="#" color="foreground" class='text-white' style={{ paddingLeft: '40px', paddingRight: '40px', fontWeight: 800, fontSize: '20px' }} >Foreground</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div class="Aggreator-2" style={{ marginTop: '40px' }}>
                <div class="Aggreator-2-1">
                    <h2 className="font-syne font-[600] text-[50px]" style={{ color: 'white', paddingTop: '70px', paddingLeft: '200px', paddingRight: '200px' }}>Find alpha before anyone else with us</h2>
                </div>
                <div class="Aggreator-2-2 flex justify-center items-center flex-col content-center lg:flex-row">
                    <div >
                        <Button color="primary" style={{ width: '100%', color: "white", padding: '35px', fontSize: '18px', borderRadius: '40px' }} className=" font-gothica1 font-[400]" startContent={<IoIosContacts style={{ fontSize: '30px' }} />}>
                            Add a list of top Twitter accounts
                        </Button>
                    </div>
                    <div >
                        <Button color="danger" style={{ width: '100%', color: "white", padding: '35px', fontSize: '18px', borderRadius: '40px' }} className=" font-gothica1 font-[400]" startContent={<MdSubscriptions style={{ fontSize: '30px' }} />}>
                            Follow their new subscriptions.
                        </Button>
                    </div>
                    <div>
                        <Button color="secondary" size='lg' style={{ width: '100%', color: "white", padding: '35px', fontSize: '18px', borderRadius: '40px' }} className=" font-gothica1 font-[400]" startContent={<FaCircleCheck style={{ fontSize: '30px' }} />}>
                            We'll show matches those subscriptions.
                        </Button>
                    </div>
                </div>
            </div>

            <div class="Aggreator-3 " style={{ paddingTop: '100px' }}>
                <div className="Aggreator-3-1">
                    <img class=" sm:w-2/4 md:w-3/4 lg:w-4/5 " src={photo} alt="Picture the" />
                </div>
                <div class="Aggreator-3-2 hidden md:hidden lg:block">
                    <Card style={{ backgroundColor: 'rgb(108, 82, 238)', width: 'auto' }}>
                        <CardBody >
                            <div class="card flex">
                                <div class="card-1 sm:flex flex-col p-7 pb-0">
                                    <div style={{ textAlign: 'left', fontSize: '35px', color: 'white', fontWeight: 700 }}>
                                        <h3 className="font-gothica1 font-[500] text-[35px]">Finding Alpha is easy</h3>
                                    </div>
                                    <div style={{ color: "white", lineHeight: '30px' }} className="font-gothica1 font-[400] text-[18px]">
                                        <p>Alpha search tool will let you be one of the first people to find the most promising alpha by tracking influencers and the most hyped projects.</p>
                                    </div>
                                </div>
                                <div className="card-2" style={{ display: 'flex' }}>
                                    <div class='' style={{ width: '50%', padding: '60px' }}>
                                        <Button color="danger" className="bordersFind w-[183px]" style={{ background: "white", color: ' #8080ff', padding: '30px', fontSize: '20px' }}>
                                            Try now for free
                                        </Button>
                                    </div>
                                    <div style={{ width: '50%', padding: '60px' }}>
                                        <Button color="danger" className="bordersFind w-[183px]" style={{ color: "white", padding: '30px', fontSize: '20px' }} startContent={<CiTwitter style={{ fontSize: '20px' }} />}>
                                            Follow Twitter
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </div>

                <div class="sm:block md:block lg:hidden">
                        <Card style={{ backgroundColor: 'rgb(108, 82, 238)', width: '100%' }}>
                            <CardBody>
                                <div class=' flex justify-center items-center flex-row'>

                                    <div>
                                        <h3 class="font-gothica1 font-[500] text-[35px] text-white p-2">Finding Alpha is easy</h3>
                                    </div>
                                    <div class='p-2'>
                                        <Button color="danger" className="bordersFind w-[183px]" style={{ background: "white", color: ' #8080ff', padding: '30px', fontSize: '20px' }}>
                                            Try now for free
                                        </Button>
                                    </div>
                                    <div class='p-2'>
                                        <Button color="danger" className="bordersFind w-[183px]" style={{ color: "white", padding: '30px', fontSize: '20px' }} startContent={<CiTwitter style={{ fontSize: '20px' }} />}>
                                            Follow Twitter
                                        </Button>

                                    </div >

                                </div>
                            </CardBody>
                        </Card>
                    </div>
            </div>
        </div>
    )
}

export default Aggreator;